<script setup>
import {ref, reactive, computed, onBeforeMount, nextTick} from 'vue'
import YTCard from "@/components/YTCard/newIndex.vue"
import BoxUpload from "@/components/YTBoxUpload/newIndex.vue"
import YTRadio from "@/components/YTRadio/index.vue";
import router from "@/router/index.js";
import YTAddress from "@/components/YTAddress/index.vue";

const props = defineProps({
  // 是否编辑状态
  isReadMode: {
    type: Boolean,
    default: false
  },
  // 双向绑定值
  modelValue: {
    required: true,
    type: Object,
  },
})

onBeforeMount(() => {
  if (props.isReadMode) {
    rules.value = rulesTwo
  }
})

const emit = defineEmits(['success', 'update:modelValue'])

// 是否编辑模式
const isEdit = ref(false)
// 协助运营状态
const assistState = ref(false)
// 加载状态
const loading = ref(false)

/*表单相关*/
// 表单锚点
const ruleFormRef = ref()
// 表单信息，实现「双向绑定」
const ruleForm = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})
// 证件正面校验规则
const checkCertificateFrontPhoto = (rule, value, callback) => {
  if(!ruleForm.value.certificateInfo.certificateFrontPhoto) return callback(new Error("请上传证件正面照"))
  return callback()
}
// 证件反面校验规则
const checkCertificateBackPhoto = (rule, value, callback) => {
  if(!ruleForm.value.certificateInfo.certificateBackPhoto) return callback(new Error("请上传证件反面照"))
  return callback()
}
// 负责人名称校验规则
const checkContactName = (rule, value, callback) => {
  if(!ruleForm.value.contactInfo.contactName) return callback(new Error("请填写负责人"))
  return callback()
}
// 负责人联系电话校验规则
const checkContactPhone = (rule, value, callback) => {
  if(!ruleForm.value.contactInfo.contactPhone) return callback(new Error("请填写负责人联系电话"))
  return callback()
}
// 企业机构代码/身份证/港澳通行证/护照校验规则
const checkCertificateId = (rule, value, callback) => {
  console.log("ruleForm", ruleForm.value)
  if(!ruleForm.value.certificateInfo.certificateId) {
    return callback(new Error(ruleForm.value.certificationType === "LEGAL_PERSON" ? "请填写企业机构代码" : "请填写身份证/港澳通行证/护照"))
  }
  return callback()
}
// 默认校验规则 - 法人企业
const rulesOne = {
  certificateFrontPhoto: [
    { required: true, validator: checkCertificateFrontPhoto}
  ],
  name: [
    { required: true, message: "请填写商家名称", trigger: 'blur' }
  ],
  certificationType: [
    { required: true, message: "请填写认证类型", trigger: 'blur' }
  ],
  certificateId: [
    { required: true, validator: checkCertificateId, trigger: 'blur' }
  ],
  entryType: [
    { required: true, message: "请选择进驻类型", trigger: 'blur' }
  ],
  contactName: [
    { required: true, validator: checkContactName, trigger: 'blur' }
  ],
  contactPhone: [
      { required: true, validator: checkContactPhone, trigger: 'blur' }
  ]
}
// 默认校验规则 - 自然人
const rulesOneLegal = {
  certificateFrontPhoto: [
    { required: true, validator: checkCertificateFrontPhoto}
  ],
  certificateBackPhoto: [
    { required: true, validator: checkCertificateBackPhoto}
  ],
  name: [
    { required: true, message: "请填写商家名称", trigger: 'blur' }
  ],
  certificationType: [
    { required: true, message: "请填写认证类型", trigger: 'blur' }
  ],
  certificateId: [
    { required: true, validator: checkCertificateId, trigger: 'blur' }
  ],
  entryType: [
    { required: true, message: "请选择进驻类型", trigger: 'blur' }
  ],
  contactName: [
    { required: true, validator: checkContactName, trigger: 'blur' }
  ],
  contactPhone: [
    { required: true, validator: checkContactPhone, trigger: 'blur' }
  ]
}
// 仅读校验规则
const rulesTwo = {}
// 编辑校验规则 - 法人企业
const rulesThree = {
  name: [
    { required: true, message: "请填写商家名称", trigger: 'blur' }
  ],
  certificateId: [
    { required: true, validator: checkCertificateId, trigger: 'blur' }
  ],
  certificateFrontPhoto: [
    { required: true, validator: checkCertificateFrontPhoto}
  ],
  entryType: [
    { required: true, message: "请选择进驻类型", trigger: 'blur' }
  ],
  contactName: [
    { required: true, validator: checkContactName, trigger: 'blur' }
  ],
  contactPhone: [
    { required: true, validator: checkContactPhone, trigger: 'blur' }
  ]
}
// 编辑校验规则 - 自然人
const rulesFour = {
  name: [
    { required: true, message: "请填写商家名称", trigger: 'blur' }
  ],
  certificateId: [
    { required: true, validator: checkCertificateId, trigger: 'blur' }
  ],
  certificateFrontPhoto: [
    { required: true, validator: checkCertificateFrontPhoto}
  ],
  certificateBackPhoto: [
    { required: true, validator: checkCertificateBackPhoto}
  ],
  entryType: [
    { required: true, message: "请选择进驻类型", trigger: 'change' }
  ],
  contactName: [
    { required: true, validator: checkContactName, trigger: 'blur' }
  ],
  contactPhone: [
    { required: true, validator: checkContactPhone, trigger: 'blur' }
  ]
}
// 表单校验规则
const rules = ref(rulesOne)
// 进驻类型枚举
const entryTypeEnum = [
  {
    label: "线上进驻",
    value: "ONLINE"
  },
  {
    label: "线下进驻",
    value: "OFFLINE"
  }
]
// 表单校验
const submit = async () => {
  loading.value = true
  await ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      await createTenant()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}
// 创建商家
const createTenant = () => {
  emit("success", ruleForm)
}
// 缓存省市区code信息
const addressCode = ref()
// 处理选择发货地址省市区
const handleSelectAddress = (data) => {
  console.log("data:", data)
  ruleForm.value.recipientInfo.recipientAddress.provinceCode = data.value[0]
  ruleForm.value.recipientInfo.recipientAddress.cityCode = data.value[1]
  ruleForm.value.recipientInfo.recipientAddress.districtCode = data.value.length > 2 ? data.value[2] : null
}
// 反显省市区code信息
const handleReviewAddressCode = (data) => {
  addressCode.value = data
}
// 处理编辑功能
const handleEdit = () => {
  isEdit.value = true
  rules.value = ruleForm.value.certificationType === "LEGAL_PERSON" ? rulesThree : rulesFour
  nextTick(() => {
    boxUploadFrontRef.value.handleReview([ruleForm.value.certificateInfo.certificateFrontPhoto])
    boxUploadBackRef.value.handleReview([ruleForm.value.certificateInfo.certificateBackPhoto])
    addressCode.value = [ruleForm.value.recipientInfo.recipientAddress.provinceCode, ruleForm.value.recipientInfo.recipientAddress.cityCode, ruleForm.value.recipientInfo.recipientAddress.districtCode]
  })
}
// 处理认证类型修改
const handleCertificationTypeChange = () => {
  if (ruleForm.value.certificationType === "LEGAL_PERSON") {
    rules.value = rulesOne
  } else if (ruleForm.value.certificationType === "NATURAL_PERSON") {
    rules.value = rulesOneLegal
  }
}

/*上传组件相关*/
// 营业执照/身份证正面上传组件锚点
const boxUploadFrontRef = ref()
// 处理正面图片列表改变
const handleFrontImageRemove = (url) => {
  ruleForm.value.certificateInfo.certificateFrontPhoto = url;
  ruleFormRef.value.validateField("certificateFrontPhoto");
}
// 处理正面图片上传成功
const handleFrontPicSuccess = (url) => {
  ruleForm.value.certificateInfo.certificateFrontPhoto = null
  ruleForm.value.certificateInfo.certificateFrontPhoto = url[0]
  ruleFormRef.value.validateField("certificateFrontPhoto");
  loading.value = false
}
// 营业执照/身份证反面上传组件锚点
const boxUploadBackRef = ref()
// 处理反面图片列表改变
const handleBackImageRemove = (url) => {
  ruleForm.value.certificateInfo.certificateBackPhoto = url;
  ruleFormRef.value.validateField("certificateBackPhoto");
}
// 处理反面图片上传成功
const handleBackPicSuccess = (url) => {
  ruleForm.value.certificateInfo.certificateBackPhoto = null
  ruleForm.value.certificateInfo.certificateBackPhoto = url[0]
  ruleFormRef.value.validateField("certificateBackPhoto");
  loading.value = false
}

defineExpose({
  handleReviewAddressCode
})
</script>

<template>
  <div class="create_container_box flex">
    <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        style="height: 100%;width: 100%;"
        class="flex"
    >
      <div class="left_wrapper">
        <YTCard :title="`${ruleForm?.certificationType === 'LEGAL_PERSON' ? '营业执照照片' : '个人身份证图片'}`">
          <template #container>
            <div class="flex_center mg_b_3">
              <div>
                <el-form-item label="证件正面：" prop="certificateFrontPhoto">
                  <div v-if="isEdit || !props.isReadMode">
                    <BoxUpload
                        :isReplaceMode="true"
                        :isRequired="true"
                        ref="boxUploadFrontRef"
                        :ali-oss-path="'SYS_TENANT_CERTIFICATE_FRONT_PHOTO'"
                        :limit="1"
                        :file-size="5"
                        @progress="loading = true"
                        @remove="handleFrontImageRemove"
                        @success="handleFrontPicSuccess"
                    ></BoxUpload>
                  </div>
                  <div v-else>
                    <el-image
                        style="width: 146px; height: 146px"
                        :src="ruleForm.certificateInfo.certificateFrontPhoto"
                        :zoom-rate="1.2"
                        :max-scale="7"
                        :min-scale="0.2"
                        :preview-src-list="[ruleForm.certificateInfo.certificateFrontPhoto]"
                        show-progress
                        :initial-index="4"
                        fit="contain"
                    />
                  </div>
                </el-form-item>
              </div>
            </div>
            <div class="flex_center">
              <div>
                <el-form-item label="证件反面：" prop="certificateBackPhoto" v-show="ruleForm.certificationType === 'NATURAL_PERSON'">
                  <div v-if="isEdit || !props.isReadMode">
                    <BoxUpload
                        :isReplaceMode="true"
                        :isRequired="ruleForm.certificationType === 'NATURAL_PERSON'"
                        ref="boxUploadBackRef"
                        :ali-oss-path="'SYS_TENANT_CERTIFICATE_BACK_PHOTO'"
                        :limit="1"
                        :file-size="5"
                        @progress="loading = true"
                        @remove="handleBackImageRemove"
                        @success="handleBackPicSuccess"
                    ></BoxUpload>
                  </div>
                  <div v-else>
                    <el-image
                        style="width: 146px; height: 146px"
                        :src="ruleForm.certificateInfo.certificateBackPhoto"
                        :zoom-rate="1.2"
                        :max-scale="7"
                        :min-scale="0.2"
                        :preview-src-list="[ruleForm.certificateInfo.certificateBackPhoto]"
                        show-progress
                        :initial-index="4"
                        fit="contain"
                    />
                  </div>
                </el-form-item>
              </div>
            </div>
          </template>
        </YTCard>
      </div>
      <div class="right_wrapper flex_1">
        <YTCard :title="`商家信息`">
          <template #container>
            <el-form-item label="商家编号：" v-if="isReadMode">
              <div class="flex_bt" style="min-width: 450px;">
                <div>
                  {{ruleForm?.tenantId}}
                </div>
                <div>
                  <v-btn v-if="!isEdit" color="primary" @click="handleEdit">编辑</v-btn>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="商家名称：" prop="name">
              <div v-if="props.isReadMode && !isEdit">
                {{ruleForm?.name}}
              </div>
              <div v-else>
                <el-input v-model="ruleForm.name" style="width: 250px;" placeholder="商家名称"/>
              </div>
            </el-form-item>
            <el-form-item label="认证类型：" prop="certificationType">
              <div v-if="props.isReadMode">
                <div v-if="ruleForm?.certificationType === 'LEGAL_PERSON'">
                  法人企业
                </div>
                <div v-else-if="ruleForm?.certificationType === 'NATURAL_PERSON'">
                  自然人
                </div>
                <div v-else>
                  未知
                </div>
              </div>
              <div v-else>
                <el-radio-group v-model="ruleForm.certificationType" @change="handleCertificationTypeChange">
                  <el-radio :value="'LEGAL_PERSON'">法人企业</el-radio>
                  <el-radio :value="'NATURAL_PERSON'">自然人</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item :label="ruleForm?.certificationType === 'LEGAL_PERSON' ? '企业机构代码：' : '身份证/港澳通行证/护照：'" prop="certificateId">
              <div v-if="props.isReadMode && !isEdit">
                <div v-if="ruleForm?.certificateInfo">
                  {{ ruleForm?.certificateInfo?.certificateId }}
                </div>
                <div v-else>
                  -
                </div>
              </div>
              <div v-else>
                <el-input v-model="ruleForm.certificateInfo.certificateId" style="width: 250px;" :placeholder="ruleForm.certificationType === 'LEGAL_PERSON' ? '企业机构代码' : '身份证/港澳通行证/护照'"/>
              </div>
            </el-form-item>
            <el-form-item label="进驻类型：" prop="entryType">
              <div v-if="props.isReadMode">
                <div v-if="ruleForm?.entryType === 'ONLINE'">
                  线上进驻
                </div>
                <div v-else-if="ruleForm?.entryType === 'OFFLINE'">
                  线下进驻
                </div>
                <div v-else>
                  未知
                </div>
              </div>
              <div v-else>
                <el-select v-model="ruleForm.entryType" placeholder="进驻类型" style="width: 240px">
                  <el-option
                      v-for="item in entryTypeEnum"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  />
                </el-select>
              </div>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`负责人信息`">
          <template #container>
            <el-form-item label="负责人：" prop="contactName">
              <div v-if="props.isReadMode && !isEdit">
                <div v-if="ruleForm?.contactInfo?.contactName">
                  {{ ruleForm.contactInfo?.contactName }}
                </div>
                <div v-else>
                  -
                </div>
              </div>
              <div v-else>
                <el-input v-model="ruleForm.contactInfo.contactName" style="width: 250px;" placeholder="负责人"/>
              </div>
            </el-form-item>
            <el-form-item label="联系电话：" prop="contactPhone">
              <div v-if="props.isReadMode && !isEdit">
                <div v-if="ruleForm?.contactInfo?.contactPhone">
                  {{ ruleForm.contactInfo?.contactPhone }}
                </div>
                <div v-else>
                  -
                </div>
              </div>
              <div v-else>
                <el-input v-model="ruleForm.contactInfo.contactPhone" style="width: 250px;" placeholder="联系电话"/>
              </div>
            </el-form-item>
            <el-form-item label="E-mail：" prop="contactEmail">
              <div v-if="props.isReadMode && !isEdit">
                <div v-if="ruleForm?.contactInfo?.contactEmail">
                  {{ ruleForm.contactInfo?.contactEmail }}
                </div>
                <div v-else>
                  -
                </div>
              </div>
              <div v-else>
                <el-input v-model="ruleForm.contactInfo.contactEmail" style="width: 250px;" placeholder="E-mail"/>
              </div>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`收款账号`">
          <template #container>
            <el-form-item label="账号名称：" prop="accountName">
              <div v-if="props.isReadMode && !isEdit">
                <div v-if="ruleForm?.payeeAccountInfo?.accountName">
                  {{ ruleForm.payeeAccountInfo?.accountName }}
                </div>
                <div v-else>
                  -
                </div>
              </div>
              <div v-else>
                <el-input v-model="ruleForm.payeeAccountInfo.accountName" style="width: 250px;" placeholder="账号名称"/>
              </div>
            </el-form-item>
            <el-form-item label="银行账号：">
              <div v-if="props.isReadMode && !isEdit">
                <div v-if="ruleForm?.payeeAccountInfo?.bankAccount">
                  {{ ruleForm.payeeAccountInfo?.bankAccount }}
                </div>
                <div v-else>
                  -
                </div>
              </div>
              <div v-else>
                <el-input v-model="ruleForm.payeeAccountInfo.bankAccount" style="width: 250px;" placeholder="银行账号"/>
              </div>
            </el-form-item>
            <el-form-item label="开户行：">
              <div v-if="props.isReadMode && !isEdit">
                <div v-if="ruleForm?.payeeAccountInfo?.bankName">
                  {{ ruleForm.payeeAccountInfo?.bankName }}
                </div>
                <div v-else>
                  -
                </div>
              </div>
              <div v-else>
                <el-input v-model="ruleForm.payeeAccountInfo.bankName" style="width: 250px;" placeholder="开户行"/>
              </div>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`收件信息`">
          <template #container>
            <el-form-item label="收件人：" prop="recipientName">
              <div v-if="props.isReadMode && !isEdit">
                <div v-if="ruleForm?.recipientInfo?.recipientName">
                  {{ ruleForm.recipientInfo?.recipientName }}
                </div>
                <div v-else>
                  -
                </div>
              </div>
              <div v-else>
                <el-input v-model="ruleForm.recipientInfo.recipientName" style="width: 250px;" placeholder="收件人"/>
              </div>
            </el-form-item>
            <el-form-item label="联系电话：">
              <div v-if="props.isReadMode && !isEdit">
                <div v-if="ruleForm?.recipientInfo?.recipientPhone">
                  {{ ruleForm.recipientInfo?.recipientPhone }}
                </div>
                <div v-else>
                  -
                </div>
              </div>
              <div v-else>
                <el-input v-model="ruleForm.recipientInfo.recipientPhone" style="width: 250px;" placeholder="联系电话"/>
              </div>
            </el-form-item>
            <el-form-item label="收件地址：">
              <div v-if="props.isReadMode && !isEdit">
                <div v-if="ruleForm?.recipientInfo.recipientAddress?.province">
                  {{ ruleForm.recipientInfo?.recipientAddress?.province }}{{ ruleForm.recipientInfo?.recipientAddress?.city }}{{ ruleForm.recipientInfo?.recipientAddress?.district }}{{ ruleForm.recipientInfo?.recipientAddress?.addressDetail }}
                </div>
                <div v-else>
                  -
                </div>
              </div>
              <div class="flex_center flex_left" v-else>
                <YTAddress class="mg_r_1" :title="'收件地址'" :addressCode="addressCode" @select="handleSelectAddress"></YTAddress>
                <el-input v-model="ruleForm.recipientInfo.recipientAddress.addressDetail" style="width: 250px;margin-top: 4px;" placeholder="收件地址"/>
              </div>
            </el-form-item>
          </template>
        </YTCard>
        <el-form-item label=" " v-if="!props.isReadMode || isEdit">
          <div>
            <v-row>
              <v-col>
                <v-btn color="primary" @click="submit">保存</v-btn>
              </v-col>
            </v-row>
          </div>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>
.create_container_box {
  width: 100%;
  height: 100%;
  .left_wrapper {
    width: 300px;
    height: 100%;
    background-color: #f7f7f7;

  }
  .right_wrapper {
    background: #fff;
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
    padding-right: 20px;
  }
}
::v-deep(.el-image) {
  background-color: #fff;
  border-radius: 15px;
  border: 1px solid #dcdfe6;
}

</style>
